// build-time 注入的合法 entry key 白名單
const allowedKeys = new Set<string>(__GH_VITE_ALLOWED_ENTRY_KEYS__);
// build-time 注入的版本 UUID
const version = __GH_VITE_BUILD_HASH__;

const assertKey = (k: string): void => {
    if (!allowedKeys.has(k)) {
        throw new Error(`[GH_VITE] 未允許的 asset key: ${k}`);
    }
};

/**
 * 掛載 window.__GH_VITE__ 動態載入介面，供 Razor 頁面動態載入 vite-app entry 的 CSS/JS
 */
export const installViteAssetLoader = (): void => {
    if (window.__GH_VITE__) return;

    // writable/configurable false + freeze 防止外部腳本覆寫或竄改 loader
    Object.defineProperty(window, '__GH_VITE__', {
        value: Object.freeze({
            v: version,
            css(k: string) {
                assertKey(k);
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = `/Scripts/vite-app/dist/vite-app.${k}.css?v=${version}`;
                document.head.appendChild(link);
            },
            // document.write 確保 IIFE 同步載完，後續 new Vue() 才能取用已註冊的元件
            js(k: string) {
                assertKey(k);
                document.write(
                    `<\x73cript src="/Scripts/vite-app/dist/vite-app.${k}.iife.js?v=${version}"></\x73cript>`
                );
            },
        }),
        writable: false,
        configurable: false,
    });
};
